import React from "react";
import './Newsbar.css';
import News from '../../News.json';

function Newsbar() {
    return (
        <div className="News-container">
            <div className="title">
                <h2>الاخبار</h2>
            </div>
            <div className="News-content">
                {News.map((content) => (
                    <p key={content.id}>{content.description}</p>
                ))}
            </div>
        </div>
    );
}

export default Newsbar;
